import { cn } from '@kidshome/ui';

/**
 * The canonical coin glyph — the deck `_icons.js` #i-coin geometry: a filled disc + a hryvnia-style
 * currency symbol (replacing the older rim+inner-ring token). Decorative (`aria-hidden`) — wherever it
 * carries meaning (a reward amount) the surrounding chip owns the label.
 *
 * It inherits `currentColor` (so the THEME colours it — gold on the warm-neutral {@link CoinChip}, and
 * whatever colour the cozy-pastel kid chip uses): ONE shape, one source of truth across both personas.
 * Sizes to `1em` so it scales with the font-size of its context with no props.
 */
export function CoinIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('inline-block size-[1.15em] shrink-0 align-[-0.15em]', className)}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 7v10M9.5 9.7h3.7a1.7 1.7 0 0 1 0 3.4H10"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
